module.exports = __webpack_public_path__ + "img/means_bg_nodeweb.c59ce3b3.svg";